import { API_BASE_URL } from "../config/api";

const ORDERS_KEY = "aio_orders_v1";

const TOKEN_KEY = "authToken";
const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY) || "";
  } catch { return ""; }
};

const authedFetch = async (url, options = {}) => {
  const headers = new Headers(options.headers || {});
  if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const token = getToken();
  if (token) headers.set("X-Auth-Token", token);
  return fetch(url, { ...options, headers });
};

const getOrderKey = () => {
  const mobileNo = localStorage.getItem("userMobileNumber") || "guest";
  return `${ORDERS_KEY}_${String(mobileNo).replace(/\D/g, "")}`;
};

const sanitize = (t) =>
  String(t ?? "")
    .replace(/₹/g, "Rs. ")
    .replace(/[“”]/g, '"')
    .replace(/[‘’]/g, "'")
    .replace(/[–—]/g, "-")
    .replace(/\s+/g, " ")
    .trim();

export const saveOrder = (order) => {
  try {
    const key = getOrderKey();
    const list = JSON.parse(localStorage.getItem(key) || "[]");
    if (!Array.isArray(list)) return;
    list.unshift(order);
    localStorage.setItem(key, JSON.stringify(list.slice(0, 100)));
  } catch (e) {
    console.warn("saveOrder failed:", e?.message);
  }
};

export const getOrders = () => {
  try {
    const key = getOrderKey();
    const list = JSON.parse(localStorage.getItem(key) || "[]");
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
};

export const createOrderRecord = ({ orderId, items = [], total = 0, walletBalanceAfter = 0 }) => {
  const date = new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  const mobileNo = localStorage.getItem("userMobileNumber");
  const profileStr = localStorage.getItem(`aio_profile_${String(mobileNo || "").replace(/\D/g, "")}`);
  let customerName = "";
  let customerAddress = "";
  let customerPin = "";
  try {
    if (profileStr) {
      const pr = JSON.parse(profileStr);
      customerName = pr?.Name || "";
      customerAddress = pr?.Address || "";
      customerPin = pr?.PinCode || "";
    }
  } catch (e) {}
  const order = {
    orderId,
    items: (items || []).map((i) => ({
      productName: i?.ProductName || i?.name || `Item`,
      price: parseFloat(i?.Price ?? i?.price) || 0,
      quantity: Number(i?.Quantity ?? i?.quantity) || 1,
      id: i?.Id ?? i?.id,
    })),
    total: parseFloat(total) || 0,
    walletBalanceAfter: walletBalanceAfter || 0,
    date,
    time: new Date().toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" }),
    customer: { name: customerName, address: customerAddress, pinCode: customerPin, mobile: mobileNo },
    status: "placed",
    createdAt: new Date().toISOString(),
  };
  saveOrder(order);
  return order;
};

export { sanitize };

// C6/L10: server-side order — total server Products table se compute karta hai.
// client se sirf ProductId + Quantity jata hai (client-price tamper impossible).
export const createServerOrder = async (items = [], profile = {}) => {
  const payload = (items || [])
    .map((i) => ({
      ProductId: Number(i?.ProductId ?? i?.id ?? i?.Id) || 0,
      Quantity: Number(i?.Quantity ?? i?.quantity) || 1,
    }))
    .filter((i) => i.ProductId > 0);
  if (!payload.length) throw new Error("No valid items");
  const res = await authedFetch(`${API_BASE_URL}/Order/Create`, {
    method: "POST",
    body: JSON.stringify({
      Items: payload,
      Profile: { Name: profile.name, Address: profile.address, PinCode: profile.pinCode },
    }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok || !data?.success) throw new Error(data?.message || "Order create failed");
  return data.order;
};

export const payServerOrder = async (orderId) => {
  const res = await authedFetch(`${API_BASE_URL}/Order/PayWithWallet`, {
    method: "POST",
    body: JSON.stringify({ OrderId: Number(orderId) }),
  });
  const data = await res.json().catch(() => null);
  if (!res.ok || !data?.success) {
    const err = new Error(data?.message || "Payment failed");
    err.balance = data?.balance;
    throw err;
  }
  return data;
};

export const getMyServerOrders = async () => {
  try {
    const res = await authedFetch(`${API_BASE_URL}/Order/GetMyOrders`);
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.success) return [];
    return Array.isArray(data.orders) ? data.orders : [];
  } catch (e) {
    return [];
  }
};

export const getServerOrder = async (id) => {
  try {
    const res = await authedFetch(`${API_BASE_URL}/Order/GetOrder?id=${Number(id)}`);
    const data = await res.json().catch(() => null);
    if (!res.ok || !data?.success) return null;
    return data.order;
  } catch (e) {
    return null;
  }
};